import axios from "axios";
import { OrderModel } from "../models";

export const takeOrder = (order: OrderModel) => {
    return axios.post("Orders/AddWebshopOrder", order);
}